<template>
  <div id="app" :class="appClass">
    <app-header
      v-if="
        version == 1 && !(layout === 'embedded' || layout === 'print' || layout === 'thumbnail')
      "
    />
    <app-error v-if="appError" v-bind="appError" class="app-overlay" />
    <template v-if="ready">
      <router-view />
    </template>
    <template v-else>
      <div class="spaceholder" />
    </template>
    <app-footer
      v-if="
        version == 1 && !(layout === 'embedded' || layout === 'print' || layout === 'thumbnail')
      "
    />
    <div v-if="!ready" class="app-loader app-overlay">
      <div class="text">Loading</div>
    </div>
  </div>
</template>

<script>
import device from '@/utils/device'
import ResponsiveCss from './mixins/ResponsiveCss'

import AppHeader from '@/components/Header.vue'
import AppFooter from '@/components/Footer.vue'
import AppError from '@/components/Error.vue'

export default {
  components: {
    'app-header': AppHeader,
    'app-footer': AppFooter,
    'app-error': AppError,
  },
  mixins: [ResponsiveCss],
  data() {
    return { preloaded: false, loading: false }
  },
  computed: {
    ready() {
      return this.preloaded === true && this.loading !== true
    },
    lng() {
      return this.$route.params.lng
    },
    appClass() {
      return `${this.deviceClass} version-${this.version} layout-${this.layout}`
    },
    deviceClass() {
      return device
    },
    tagTree() {
      return this.$store.state.tags.tree
    },
    version() {
      return this.$route.params.version
    },
    layout() {
      return this.$route.params.layout
    },
    versionInfo() {
      return this.$store.state.external.versionInfo
    },
    appError() {
      return this.dataError || this.apiError
    },
    dataError() {
      return this.$store.getters.dataError
    },
    apiError() {
      return this.$store.getters.apiError
    },
  },
  watch: {
    appError(to) {
      if (to) {
        this.preloaded = true
        this.loading = false
      }
    },
  },
  beforeMount() {
    Promise.all([
      // this.$store.dispatch('getVersions'),
      this.$store.dispatch('getVersionInfo', {
        versionId: this.version,
      }),
      this.$store.dispatch('getLanguage', {
        lngId: this.lng,
      }),
      this.$store.dispatch('getTagTree', {
        versionId: this.version,
      }),
    ]).then(() => {
		if (this.$route.params.versionName !== this.$store.state.external.versionInfo.versionName) {
			this.$router.updateVersionName(this.$store.state.external.versionInfo.versionName)
		}
		this.preloaded = true
	})

    this.$root.$on('loader:display', () => {
      this.loading = true
    })

    this.$root
      .$on('loader:hide', () => {
        this.loading = false
      })
  },
}
</script>

<style lang="stylus">
@import "./styles/main"

#app
	height: 100vh
	overflow-x: hidden
	overflow-y: auto

	&.mobile
		.app-loader
			background-size: 120px

			.text
				padding-top: 140px

	.app-loader
		background-image: url("assets/images/oecd-loader.gif")
		background-size: 100px

		.text
			padding-top: 180px

	.spaceholder
		background-color: white
		height: 100%

		.layout-explore.version-1 &
			height: calc(100% - 102px)

			+m-breakpoint(sm, xmd)
				height: calc(100% - 64px)
</style>
